// ═══════════════════════════════════════════════════════════════
// ClearView CRM Debug Logger
// Layer 1 of debugging strategy per Modularization Blueprint
// 4 categories: action, data, error, warn
// ═══════════════════════════════════════════════════════════════

const DEBUG_MODE = process.env.NODE_ENV !== "production";
const PREFIX = "🔍 [ClearView Debug]";

export const debugLog = {
  /** User actions: clicks, form submissions, navigation */
  action: (message, data = null) => {
    if (DEBUG_MODE) console.log(`${PREFIX} 👆 ${message}`, data || "");
  },

  /** Data operations: localStorage, CSV import, backup/restore */
  data: (message, data = null) => {
    if (DEBUG_MODE) console.log(`${PREFIX} 💾 ${message}`, data || "");
  },

  /** Errors: always logs, even when debug mode is off */
  error: (context, error) => {
    console.error(`${PREFIX} ❌ Error in ${context}:`, {
      message: error?.message || error,
      code: error?.code,
      details: error?.details,
      hint: error?.hint,
      status: error?.status,
      stack: error?.stack
    });
  },

  /** Soft failures and data inconsistencies */
  warn: (context, message, data = null) => {
    if (DEBUG_MODE) console.warn(`${PREFIX} ⚠️ ${context}: ${message}`, data || "");
  }
};
